import {type IColumn } from "@fluentui/react";
import React, { useState } from "react";
import AcceptedCell from "../cells/AcceptedCell";
import styles from "../../../constructionsNew.module.scss";
import IsGeometricallyValidCell from "../cells/IsGeometricallyValidCell";
import type ConstructionListItem from "../../../types/ConstructionListItem";
import TagsCell from "../cells/TagsCell";

const useConstructionsNewTableColumns = (
    handleSorting: (columnName: keyof ConstructionListItem, isSortedDescending: boolean) => void,
): IColumn[] => {
    const handleColumnClick = (
        ev?: React.MouseEvent<HTMLElement>,
        column?: IColumn,
    ): void => {
        const {key, isSortedDescending} = column ?? {};
      
        setColumns(
          columns.map(clm => {
            if (clm.key === key) {
              clm.isSorted = true;
              clm.isSortedDescending = !isSortedDescending;
              return clm;
            }
          
            clm.isSorted = false;
            clm.isSortedDescending = false;
            return clm;
          }),
        );
        if (key) handleSorting(key as keyof ConstructionListItem, isSortedDescending ?? false);
    };

    const [columns, setColumns] = useState<IColumn[]>([
    {
      key: "locationCode",
      name: "Location code",
      fieldName: "locationCode",
      minWidth: 100,
      maxWidth: 120,
      isResizable: true,
      isSorted: false,
      ariaLabel: "Location code",
      className: styles.centerText,
      onColumnClick: handleColumnClick,
    },
    {
      key: "name",
      name: "Name",
      fieldName: "name",
      minWidth: 180,
      maxWidth: 300,
      flexGrow: 1,
      isResizable: true,
      isSorted: false,
      ariaLabel: "Name",
      onColumnClick: handleColumnClick,
    },
    {
      key: "phase",
      name: "Phase",
      fieldName: "phase",
      minWidth: 80,
      maxWidth: 100,
      isResizable: true,
      isSorted: false,
      ariaLabel: "Phase",
      className: styles.centerText,
    },
    {
      key: "locationType",
      name: "Location type",
      fieldName: "locationType",
      minWidth: 80,
      maxWidth: 100,
      isResizable: true,
      isSorted: false,
      ariaLabel: "Location type",
      className: styles.centerText,
    },
    {
      key: "status",
      name: "State",
      fieldName: "status",
      minWidth: 50,
      maxWidth: 100,
      isResizable: true,
      isSorted: false,
      ariaLabel: "Accepted",
      className: styles.centerText,
      onRender: (item: ConstructionListItem) => <AcceptedCell constructionStatus={item.status} />,
    },
    {
      key: "isGeometricallyValid",
      name: "Valid Geometrically",
      fieldName: "isGeometricallyValid",
      minWidth: 50,
      maxWidth: 100,
      isResizable: true,
      isSorted: false,
      ariaLabel: "Valid Geometrically",
      className: styles.centerText,
      onRender: (item: ConstructionListItem) => (
        <IsGeometricallyValidCell
          geometricalValidationErrorMessages={
            item.geometricalValidationErrorMessages
          }
          isGeometricallyValid={item.isGeometricallyValid}
        />
      ),
    },
    {
      key: "sortCreatedOn",
      name: "Created",
      fieldName: "createdOn",
      minWidth: 100,
      maxWidth: 100,
      isResizable: true,
      isSorted: true,
      isSortedDescending: true,
      ariaLabel: "Created",
      className: styles.centerText,
      onColumnClick: handleColumnClick,
    },
    {
      key: "createdBy",
      name: "Created by",
      fieldName: "createdBy",
      minWidth: 120,
      maxWidth: 140,
      isResizable: true,
      ariaLabel: "Created By",
      className: styles.centerText,
    },
    {
      key: "updateCalculationTimeStamp",
      name: "Updated Calculation on",
      fieldName: "updateCalculationTimeStamp",
      minWidth: 200,
      maxWidth: 200,
      ariaLabel: "Update on",
      className: styles.centerText,
    },
    {
      key: "tag",
      name: "Tags",
      fieldName: "tags",
      minWidth: 200,
      maxWidth: 200,
      isResizable: true,
      ariaLabel: "Tags",
      onRender: (item: ConstructionListItem) => <TagsCell tags={item.tags} />,
    },
  ]);

  return columns;
};

export default useConstructionsNewTableColumns;